import React, { useState, memo } from 'react';
const FAQ = () => {
  const faqs = [{
    question: 'How does SmartSoda enhance the spa guest experience?',
    answer: 'SmartSoda provides premium alkaline, vitamin-infused, and functional beverages that complement your spa treatments and create memorable moments for your guests—without artificial ingredients or excessive sugars.'
  }, {
    question: 'How does SmartSoda support our wellness philosophy?',
    answer: 'Our clean-label, functional beverages align perfectly with spa wellness goals, offering options that can be customized to complement specific treatments and enhance the holistic benefits your spa provides.'
  }, {
    question: 'How does SmartSoda help with client retention?',
    answer: 'By creating memorable, personalized beverage experiences, SmartSoda helps increase guest satisfaction by 15-20% on average. This enhanced experience leads to higher rebooking rates and improved lifetime client value.'
  }, {
    question: 'What types of beverages are available?',
    answer: 'SmartSoda offers a wide selection, including vitamin-infused waters, alkaline waters, sparkling waters, functional wellness drinks, herbal-infused options, detox waters, and more—with customizable carbonation and functional wellness shots.'
  }, {
    question: 'How does the system work in a spa environment?',
    answer: 'Our sleek, quiet dispensers can be placed in reception areas, relaxation lounges, or treatment rooms. The intuitive interface allows staff or guests to create the perfect beverage with just a few taps.'
  }, {
    question: 'Can we customize beverages for different treatments?',
    answer: 'Yes! Many spas create signature beverages that complement specific treatments—detoxifying drinks for body wraps, revitalizing options for facials, or calming herbal-infused waters for massage therapy.'
  }, {
    question: 'How much space does a SmartSoda dispenser require?',
    answer: 'Our machines are compact and designed to blend seamlessly into luxury spa environments, requiring minimal counter space while making a maximum impression.'
  }, {
    question: "What's required for installation?",
    answer: 'SmartSoda dispensers connect to your existing water source and power supply, making installation quick and hassle-free. Professional installation is handled by our certified technicians.'
  }, {
    question: 'Can we brand the beverages as our own?',
    answer: 'Yes! Many spas create their own signature beverage menu with custom names that reflect their brand. We provide beautiful menu templates and can help develop signature drink recipes.'
  }, {
    question: 'How can I get started?',
    answer: "Contact us today to schedule a consultation and bring SmartSoda to your spa! We'll create a custom solution that perfectly complements your spa experience."
  }];
  const [openIndex, setOpenIndex] = useState(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };
  return <section className="py-20 bg-gray-50" id="faq" data-id="element-179">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-180">
        <div className="text-center mb-16" data-id="element-181">
          <h2 className="text-3xl font-bold text-navy-950 sm:text-4xl" data-id="element-182">
            Frequently Asked Questions
          </h2>
          <p className="mt-4 text-lg text-gray-600" data-id="element-183">
            Everything you need to know about SmartSoda for your spa
          </p>
        </div>
        <div className="bg-white rounded-2xl shadow-sm overflow-hidden" data-id="element-184">
          {faqs.map((faq, index) => <div key={index} className="border-b border-gray-100 last:border-b-0" data-id="element-185">
              <button className="w-full px-6 py-5 text-left focus:outline-none" onClick={() => toggleFAQ(index)} aria-expanded={openIndex === index} data-id="element-186">
                <div className="flex justify-between items-center" data-id="element-187">
                  <h3 className="text-lg font-medium text-navy-950" data-id="element-188">
                    {faq.question}
                  </h3>
                  <span className="ml-6 flex-shrink-0" data-id="element-189">
                    <svg className={`h-6 w-6 transform ${openIndex === index ? 'rotate-180' : 'rotate-0'} transition-transform duration-200 ease-in-out text-gray-500`} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-190">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7" data-id="element-191" />
                    </svg>
                  </span>
                </div>
              </button>
              <div className={`overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-96 pb-6' : 'max-h-0'}`} data-id="element-192">
                <div className="px-6 text-gray-600" data-id="element-193">{faq.answer}</div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};
export default FAQ;